import React from 'react';
import { Button } from '../../../ui/button';
import { Edit } from 'lucide-react';

/**
 * Read-only summary card for a single Sales Data combination.
 */
const SalesDataCard = ({ salesData, index, names, onEdit }) => {
  const { getSalesOrgName, getDistChannelName, getPlantName } = names;

  return (
    <div
      data-testid={`sales-data-card-${index}`}
      className="border-2 border-orange-200 rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow"
    >
      {/* Header with combination */}
      <div className="bg-gradient-to-r from-orange-50 to-orange-50 px-5 py-4 border-b border-orange-100">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-600 text-white">
                Sales Org + Dist Channel
              </span>
            </div>
            <h4 className="text-lg font-bold text-gray-900 mb-1">
              {getSalesOrgName(salesData.sales_org_id)} → {getDistChannelName(salesData.dist_channel_id)}
            </h4>
            <div className="flex items-center gap-2 text-sm">
              <span className="text-gray-500">Plant:</span>
              <span className="font-semibold text-gray-900">{getPlantName(salesData.plant_id)}</span>
            </div>
          </div>
          <div className="flex gap-2">
            <Button
              size="sm"
              variant="outline"
              onClick={() => onEdit(index)}
              data-testid={`sales-data-edit-${index}`}
              className="flex items-center gap-1 border-orange-300 hover:bg-orange-50"
            >
              <Edit className="w-3.5 h-3.5" />
              Edit
            </Button>
          </div>
        </div>
      </div>

      {/* Data fields */}
      <div className="p-5">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
          <Field label="Sales Unit" value={salesData.sales_unit} />
          <Field label="Availability Check" value={salesData.availability_check} />
          <Field label="Profit Center" value={salesData.profit_center} />
          <Field label="Transportation Group" value={salesData.transportation_group} />
          <Field label="Loading Group" value={salesData.loading_group} />
          <Field label="Min Order Qty" value={salesData.min_order_qty} />
        </div>

        {/* ATP Lead Times */}
        <div className="mt-4 pt-4 border-t border-gray-100">
          <p className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">ATP Lead Times</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
            <LeadTime label="Loading Time" value={salesData.loading_time} />
            <LeadTime label="Pick/Pack Time" value={salesData.pick_pack_time} />
          </div>
        </div>
      </div>
    </div>
  );
};

const Field = ({ label, value }) => (
  <div>
    <p className="text-gray-500 mb-1">{label}</p>
    <p className="font-medium text-gray-900">{value || '-'}</p>
  </div>
);

const LeadTime = ({ label, value }) => (
  <div className="bg-gray-50 rounded px-3 py-2">
    <p className="text-gray-500 text-xs">{label}</p>
    <p className="font-medium text-gray-900">
      {value ? `${value} days` : <span className="text-amber-600">Default</span>}
    </p>
  </div>
);

export default SalesDataCard;
